module.exports = __webpack_public_path__ + "static/media/2omb-01.ea11f985.png";